export default function GetToKnowGod() {
    return (
        <div class = 'content'>
            <div id = 'bible-verses'>
                <div class = 'image-card'>
                    <img src = 'https://static.secure.website/wspfus/0/765/open-book-bible-on-brown-wooden-table-w866-o.jpg' alt = 'bible-on-table' />
                    <div class = 'text'>
                        <h2>If you are not a believer, please find a bible read these passages:</h2>
                        <div class = 'verses'>
                            <ul id = 'verse-list'>
                                <li>John 3:16</li>
                                <li>Isaiah 53:6</li>
                                <li>Romans 6:23</li>
                                <li>Titus 3:5</li>
                                <li>Colossians 1:15,16</li>
                                <li>1 Corinthians 15:3-6</li>
                                <li>John 14:6</li>
                                <li>John 7:37,38</li>
                                <li>John 1:12</li>
                                <li>Ephesians 2:8,9</li>
                                <li>John 3:1-8</li>
                                <li>John 10:10</li>
                                <li>Revelation 3:20</li>
                                <li>Philippians 4:13</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div id = 'bible-links'>
                <div class = 'image-card'>
                    <img src = 'https://static.secure.website/wspfus/0/4223/sky-sunset-person-silhouette-w940.jpeg' alt = 'sunset-person;' />
                    <div class = 'text'>
                        <h2>Useful links:</h2>
                        <ol>
                            <li>
                                <a href = 'https://www.churchofjesuschrist.org/comeuntochrist/lp/requests/missionary-visit?cid=C15856363587G138717384858A602705674974&adlang=eng&source=google&network=g&gclid=CjwKCAjwloynBhBbEiwAGY25dIJ_DjFOjzNV0TdwNHmL6yLJ-CU4iamqF1ZIfzKC8zRcLWYa4a7ZYxoCrJkQAvD_BwE' target = '_blank' rel = 'noreferrer'>
                                    Meet with the missionaries
                                </a>
                            </li>
                            <li>
                                <a href = 'http://www.gty.org/resources/sermons/80-122/the-benefits-of-knowing-christ' target = '_blank' rel = 'noreferrer'>
                                    The benefits of knowing Christ
                                </a>
                            </li>
                            <li>
                                <a href = 'http://www.everystudent.com/features/gettingconnected.html' target = '_blank' rel = 'noreferrer'>
                                    Getting connected to God
                                </a>
                            </li>
                            <li>
                                <a href = 'https://www.facebook.com/More.of.God/' target = '_blank' rel = 'noreferrer'>
                                    More of God
                                </a>
                            </li>
                            <li>
                                <a href = 'https://gotquestions.org/know-God.html' target = '_blank' rel = 'noreferrer'>
                                    Knowing God
                                </a>
                            </li>
                            <li>
                                <a href = 'https://www.cru.org/how-to-know-god/would-you-like-to-know-god-personally.html' target = '_blank' rel = 'noreferrer'>
                                    Would you like to know God personally?
                                </a>
                            </li>
                            <li>
                                <a href = 'https://bible.org/'>
                                    Bible.org
                                </a>
                            </li>
                            <li>
                                <a href = 'https://www.youtube.com/watch?v=uZL2y7rXYJQ' target = '_blank' rel = 'noreferrer'>
                                    How Do I Get to Know God Better?
                                </a>
                            </li>
                            <li>
                                <a href = 'http://www.gty.org/resources/questions/QA169/i-want-to-know-gods-word-better-can-you-provide-me-with-a-plan-to-help-me-get-there' target = '_blank' rel = 'noreferrer'>
                                    A plan to get to know God's word better
                                </a>
                            </li>
                        </ol>
                    </div>
                    
                </div>
            </div>
        </div>
    );
}